import { useOktaAuth } from '@okta/okta-react';
import type { FC } from 'react';

/** Render the provided children only when okta context exists */
export const RenderWhenOktaEnabled: FC<any> = ({ children }) => {
    // Default behavior for production/development
    const oktaExists = Boolean(useOktaAuth());
    if (oktaExists) {
        return children;
    }

    // Check for TestCafe mock (for integration tests)
    // Check both window object and localStorage to handle page reloads
    if (typeof window !== 'undefined') {
        const windowMockEnabled = (window as any).__TESTCAFE_OKTA_ENABLED__;
        const localStorageMockEnabled = localStorage.getItem('__TESTCAFE_OKTA_ENABLED__') === 'true';

        if (windowMockEnabled !== undefined || localStorageMockEnabled) {
            const isEnabled = windowMockEnabled !== undefined ? windowMockEnabled : localStorageMockEnabled;

            // Restore window mock from localStorage if needed
            if (windowMockEnabled === undefined && localStorageMockEnabled) {
                (window as any).__TESTCAFE_OKTA_ENABLED__ = true;
            }

            return isEnabled ? children : null;
        }
    }

    return null;
};
